import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/css";

export default function initPublicationCarousel() {
  const wrappers = document.querySelectorAll(".publication-carousel-wrapper");

  if (!wrappers.length) return;

  wrappers.forEach((wrapper) => {
    const swiperContainer = wrapper.querySelector(".swiper");
    const prevButton = wrapper.querySelector(".carousel-button-prev");
    const nextButton = wrapper.querySelector(".carousel-button-next");
    const progressBar = wrapper.querySelector(".carousel-progress-bar");
    const controls = wrapper.querySelector(".carousel-controls");

    if (!swiperContainer) return;

    function updateProgressBar(swiper) {
      if (!progressBar) return;
      const total = swiper.slides.length;
      const perView =
        typeof swiper.params.slidesPerView === "number"
          ? swiper.params.slidesPerView
          : 1;
      const visible = Math.min(perView / total, 1);
      const scrollProgress = Math.min(Math.max(swiper.progress, 0), 1);
      const progress = (visible + scrollProgress * (1 - visible)) * 100;
      progressBar.style.width = `${Math.min(progress, 100)}%`;
    }

    function updateControlsVisibility(swiper) {
      if (!controls) return;
      const perView =
        typeof swiper.params.slidesPerView === "number"
          ? swiper.params.slidesPerView
          : 1;
      controls.style.display = swiper.slides.length <= perView ? "none" : "";
    }

    new Swiper(swiperContainer, {
      modules: [Navigation],
      slidesPerView: 3,
      spaceBetween: 32,
      grabCursor: true,
      loop: false,
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
      on: {
        init: function () {
          updateProgressBar(this);
          updateControlsVisibility(this);
        },
        slideChange: function () {
          updateProgressBar(this);
        },
        progress: function () {
          updateProgressBar(this);
        },
        resize: function () {
          updateControlsVisibility(this);
        },
      },
    });
  });
}
